module.exports = __webpack_public_path__ + "img/Screen06.eac3c4e3.svg";